import React from 'react';
import { styled } from '@linaria/react';

import Slider from './VerticalChannelSlider';
import {
  pluckHexValues,
  convertToHexadecimal,
} from './HexColorPicker.helpers';

function HexColorPicker({ dynamicGradients = false }) {
  const [color, setColor] = React.useState('FF0000');

  const { r, g, b } = pluckHexValues(color);

  const changeColor = React.useCallback((channel, value) => {
    setColor((currentColor) => {
      const colorObj = pluckHexValues(currentColor);

      // Convert to hexadecimal color
      colorObj[channel] = convertToHexadecimal(value);

      return `${colorObj.r}${colorObj.g}${colorObj.b}`;
    });
  }, []);

  return (
    <Wrapper style={{ color: `#${color}` }}>
      #
      <Slider
        value={r}
        channel="r"
        color={color}
        dynamicGradients={dynamicGradients}
        onChange={changeColor}
      />
      <Slider
        value={g}
        channel="g"
        color={color}
        dynamicGradients={dynamicGradients}
        onChange={changeColor}
      />
      <Slider
        value={b}
        channel="b"
        color={color}
        dynamicGradients={dynamicGradients}
        onChange={changeColor}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 64px;
  letter-spacing: -2px;
  font-family: var(--font-family-mono);
  font-size: 3rem;
  /* prettier-ignore */
  text-shadow:
    0px 0.5px 1px hsl(0deg 0% 0% / 0.1),
    0px 1px 2px hsl(0deg 0% 0% / 0.1),
    0px 4px 8px hsl(0deg 0% 0% / 0.1),
    0px 8px 16px hsl(0deg 0% 0% / 0.1);
`;

export default React.memo(HexColorPicker);
